module.exports = function() {
  return new Worker(__webpack_public_path__ + "1bddaf1110d8e26d0071.worker.js");
};